import React, { useEffect } from 'react';
import Text from '~components/atoms/Text';
import CustomSkeleton from '~components/atoms/Skeleton';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { FundTypeEnum, GoldTypeEnum } from '~utils/enums';

import * as Styles from './_preciousMetalPricingTable.module.scss';

const PreciousMetalPricingTable = () => {
    const dispatch = useAppDispatch();
    const dashboardProductPricing = useAppSelector(state => state.dashboard.dashboardProductPricing);
    const loading = useAppSelector(state => state.dashboard.loadings.getDashboardProductPricing);
    const error = useAppSelector(state => state.dashboard.errors.getDashboardProductPricing);

    const tableHeader = [
        'Denomination',
        'Bank Sell (MYR) per gram',
        'Bank Buy (MYR) per gram',
    ];

    const preciousMetalPricing = dashboardProductPricing.filter(product => product.fundType === FundTypeEnum.Conventional);

    const renderTableHeader = () => {
        return tableHeader.map((header, index) => {
            return (
                <th key={index}>
                    {header}
                </th>
            );
        });
    };

    const renderTableBody = () => {
        if (loading && preciousMetalPricing.length === 0) { // loading only on the first render
            return (
                <tr>
                    <td colSpan={3}>
                        <CustomSkeleton height={40} />
                    </td>
                </tr>
            );
        }

        if (error) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label={error}
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (!preciousMetalPricing.length) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label='No data found'
                            isError
                        />
                    </td>
                </tr>
            );
        }
        return preciousMetalPricing.map((product, index) => {
            return (
                <tr key={index}>
                    <td>{product.productName}</td>
                    <td>{typeof product.sellPrice === 'number' ? (Math.round(product.sellPrice * 100) / 100).toFixed(2) : '-'}</td>
                    <td>{typeof product.buyPrice === 'number' ? (Math.round(product.buyPrice * 100) / 100).toFixed(2) : '-'}</td>
                </tr>
            );
        });
    };

    return (
        <div className={Styles.container}>
            <Text
                label='Precious Metal'
                className={Styles.title}
                isBold
            />

            <table className={Styles['table-container']}>
                <thead>
                    <tr>
                        {renderTableHeader()}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={3} />
                    </tr>
                    {renderTableBody()}
                </tbody>
            </table>
        </div>
    );
};

export default PreciousMetalPricingTable;
